var redefine = require('./$.redefine');
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/babel-runtime/~/core-js/library/modules/$.redefine-all.js
// module id = 757
// module chunks = 0